import React, { useEffect, useMemo, useState } from 'react';
import useTheme from '../hooks/useTheme';
import { IComponentHot, IComponentHotOne } from '../../component';
import { alpha } from '../../utils/color';
import image from '../../actions/image';

//  这是后端约定的, 如果是相册/标签汇总模式, 前端最多展示20张图片, 超过20张的部分后端不返回了
const MAX_DISPLAY_WITH_MORE = 20;

export default function(props: IComponentHot) {
  const theme = useTheme();
  const { h1Color } = theme;
  const { hot_list, dataSource, gallery_list, tag, sortType, sortOrder, showMore } = props;

  const [bigIndex, setBigIndex] = useState(-1 as number);
  const [albumImages, setAlbumImages] = useState([] as IComponentHotOne[]);
  const [loading, setLoading] = useState(false);

  // 从相册/标签汇总接口拉取图片
  useEffect(() => {
    if (dataSource !== 'album' || !gallery_list || !gallery_list.length) {
      setAlbumImages([]);
      return;
    }

    setLoading(true);
    // sortType 映射: 管理端存储的格式 → API所需的格式
    // shoot_time → shoottime, upload_time → uploadtime, index → index (热度)
    const sortTypeMap: Record<string, string> = {
      'shoot_time': 'shoottime',
      'upload_time': 'uploadtime',
      'index': 'index',
    };
    const apiSortType = sortTypeMap[sortType || 'shoot_time'] || 'shoottime';
    const apiOrder = sortOrder || 'desc';

    // gallery_list 可能是字符串或数字数组，统一转为字符串数组确保序列化一致
    const galleryIds = (gallery_list || []).map((id: any) => String(id));

    image.tagList({
      sorttype: apiSortType,
      order: apiOrder,
      galleryid: 0,
      tag: tag || '',
      offset: 0,
      galleryids: galleryIds,
    }).then((res) => {
      const items = (res.data || []).map((item: any, index: number) => ({
        tId: item.id || `album_${index}`,
        image: item.raw_path || item.hash || '',
        link: { type: '' } as any,
        desc: '',
      }));

      // 相册/标签汇总模式固定最多展示前20张
      setAlbumImages(items.slice(0, MAX_DISPLAY_WITH_MORE));
      setLoading(false);
    }).catch(() => {
      setAlbumImages([]);
      setLoading(false);
    });
  }, [dataSource, gallery_list, tag, sortType, sortOrder]);

  // manual 模式下：上传多少展示多少，不做前端截断
  const manualDisplayList = useMemo(
    () => (hot_list || []),
    [hot_list]
  );

  // 确定最终渲染的列表
  const displayList = useMemo(
    () => (dataSource === 'album' ? albumImages : manualDisplayList),
    [dataSource, albumImages, manualDisplayList]
  );
  const bigSourceList = useMemo(
    () => displayList,
    [displayList]
  );

  const bigList = useMemo(
    () =>
      bigSourceList.map((it: IComponentHotOne, index: number) => {
        return {
          id: index,
          hash: it.image,
          link: it.link,
        };
      }),
    [bigSourceList]
  );

  const borderColor = alpha(h1Color, 0.2);

  return {
    setBigIndex,
    borderColor,
    h1Color,
    bigIndex,
    bigList,
    displayList,
    loading,
  };
}
